// printess-editor-state.js
(function () {
  if (window.__printessEditorStateInit) return;
  window.__printessEditorStateInit = true;

  const COMPONENT_SELECTOR = 'printess-component';
  const POLL_MS = 600;
  const API_TIMEOUT_MS = 60000; // Editor wird evtl. erst später geöffnet

  const BADGE_ID = 'PrintessEditorStateBadge';
  const STYLE_ID = 'PrintessEditorStateStyle';

  // Interner Zustand:
  // - dirty kommt von Printess (hasUnsavedChanges)
  // - hasSavedOnce ist unsere Zusatzprüfung: erst nach einem Save darf "Gespeichert" erscheinen
  let hasSavedOnce = false;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const getComponent = () => document.querySelector(COMPONENT_SELECTOR);

  const getShadowRoot = () => {
    const c = getComponent();
    return c?.shadowRoot || null;
  };

  const getApi = () => {
    const c = getComponent();
    return c?.editor?.api || null;
  };

  async function waitForApi() {
    const start = Date.now();
    while (Date.now() - start < API_TIMEOUT_MS) {
      const api = getApi();
      if (api && typeof api.hasUnsavedChanges === 'function') return api;
      await sleep(150);
    }
    return null;
  }

  function ensureStyle(root) {
    if (!root) return;
    if (root.getElementById?.(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${BADGE_ID} {
        margin-left: 10px;
        font-size: 12px;
        font-weight: 600;
        padding: 6px 10px;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        line-height: 1;
        user-select: none;
      }

      /* "Gespeichert" */
      #${BADGE_ID}[data-state="saved"] {
        background: rgba(16, 185, 129, 0.12);
        color: rgba(16, 185, 129, 1);
      }

      /* "Nicht gespeichert" */
      #${BADGE_ID}[data-state="unsaved"] {
        background: rgba(245, 158, 11, 0.14);
        color: rgba(245, 158, 11, 1);
      }
    `;

    root.appendChild(style);
  }

  function findSaveAnchor(root) {
    if (!root) return null;

    // PanelUI: bc-button[action="save"] ist der sauberste Hook
    const saveBcButton = root.querySelector('bc-button[action="save"]');
    if (saveBcButton) return saveBcButton;

    // Fallback: suche echten Button "SPEICHERN"
    const btn = Array.from(root.querySelectorAll('button')).find(
      (b) => (b.textContent || '').trim().toUpperCase() === 'SPEICHERN'
    );
    return btn || null;
  }

  function ensureBadge(root) {
    if (!root) return null;

    let badge = root.getElementById?.(BADGE_ID) || root.querySelector(`#${BADGE_ID}`);
    if (badge) return badge;

    const anchor = findSaveAnchor(root);
    if (!anchor) return null;

    badge = document.createElement('span');
    badge.id = BADGE_ID;

    // Default: beim ersten Öffnen IMMER "Nicht gespeichert",
    // auch wenn Printess hasUnsavedChanges() initial false liefert.
    badge.setAttribute('data-state', 'unsaved');
    badge.textContent = 'Nicht gespeichert';

    anchor.insertAdjacentElement('afterend', badge);
    return badge;
  }

  function setBadgeState(root, dirty, savedOnce) {
    const badge = ensureBadge(root);
    if (!badge) return;

    // 2 sichtbare Zustände (mit Zusatzprüfung):
    // Gespeichert nur wenn bereits mind. 1x gespeichert UND aktuell nicht dirty.
    const isSaved = !!savedOnce && !dirty;

    const next = isSaved ? 'saved' : 'unsaved';
    if (badge.getAttribute('data-state') === next) return;

    badge.setAttribute('data-state', next);
    badge.textContent = isSaved ? 'Gespeichert' : 'Nicht gespeichert';
  }

  function watchUiMount() {
    const root = getShadowRoot();
    if (!root) return;

    ensureStyle(root);
    ensureBadge(root);

    const obs = new MutationObserver(() => {
      const r = getShadowRoot();
      if (!r) return;
      ensureStyle(r);
      ensureBadge(r);
    });

    obs.observe(root, { childList: true, subtree: true });

    // Falls printess-component neu rendert / ShadowRoot wechselt
    const outerObs = new MutationObserver(() => {
      const r = getShadowRoot();
      if (!r) return;
      ensureStyle(r);
      ensureBadge(r);
    });

    outerObs.observe(document.documentElement, { childList: true, subtree: true });

    return () => {
      obs.disconnect();
      outerObs.disconnect();
    };
  }

  async function start() {
    const api = await waitForApi();
    if (!api) {
      console.warn('[PRINTESS][STATE] API not ready (no editor.api.hasUnsavedChanges())');
      return;
    }

    const stopWatching = watchUiMount();

    let lastDirty = null;

    const readDirty = () => {
      try {
        return !!api.hasUnsavedChanges();
      } catch (err) {
        console.warn('[PRINTESS][STATE] hasUnsavedChanges() failed:', err);
        return lastDirty ?? false;
      }
    };

    // 1) Hook: erfolgreicher Save -> ab jetzt darf "Gespeichert" überhaupt erst erscheinen
    document.addEventListener('printess:saved', () => {
      hasSavedOnce = true;

      const dirtyNow = readDirty();
      const r = getShadowRoot();
      if (r) {
        ensureStyle(r);
        setBadgeState(r, dirtyNow, hasSavedOnce);
      }
    });

    // initial (Badge default ist "Nicht gespeichert", aber wir syncen trotzdem)
    lastDirty = readDirty();
    const root = getShadowRoot();
    if (root) {
      ensureStyle(root);
      setBadgeState(root, lastDirty, hasSavedOnce);
    }

    // polling reicht, weil Printess kein Dirty-Event liefert
    const t = window.setInterval(() => {
      const dirtyNow = readDirty();
      if (dirtyNow === lastDirty) return;
      lastDirty = dirtyNow;

      const r = getShadowRoot();
      if (!r) return;
      ensureStyle(r);
      setBadgeState(r, dirtyNow, hasSavedOnce);
    }, POLL_MS);

    window.addEventListener('pagehide', () => {
      window.clearInterval(t);
      if (typeof stopWatching === 'function') stopWatching();
    });
  }

  start();
})();